import { string, addMethod } from 'yup';

export default () => {
  // eslint-disable-next-line func-names
  addMethod(string, 'validEmail', function () {
    return this.test({
      name: 'validEmail',
      message: 'Email is not valid',
      test: (email = '') => string().email().isValid(email),
    });
  });
};
